// extracted by mini-css-extract-plugin
export default {"content":"styles_content__iveqN","titleWrap":"styles_titleWrap__895Ld","actions":"styles_actions__HAhAf"};